if (!customElements.get('gift-packing')) {
  customElements.define(
    'gift-packing',
    class GiftPacking extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.checkbox = this.querySelector('.gift-packing__checkbox');
        this.message = this.querySelector('.gift-packing__message');
        this.textarea = this.querySelector('.gift-packing__textarea');
        this.count = this.querySelector('.gift-packing__count');
        this.form = document.getElementById(this.dataset.formId);

        this.checkbox.addEventListener('change', this.onToggle.bind(this));
        if (this.textarea) this.textarea.addEventListener('input', this.updateCount.bind(this));
        // Drop an empty gift message so it doesn't show as a blank property on the order
        if (this.form) this.form.addEventListener('formdata', this.onFormData.bind(this));

        if (this.dataset.variantId) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      onToggle() {
        const checked = this.checkbox.checked;
        this.classList.toggle('is-selected', checked);
        if (this.dataset.variantId) this.toggleBuyNow(checked);
        if (!this.message) return;
        this.message.hidden = !checked;
        this.textarea.disabled = !checked;
        if (checked) this.textarea.focus();
      }

      updateCount() {
        this.count.textContent = `${this.textarea.value.length}/${this.textarea.maxLength}`;
      }

      onFormData(event) {
        if (this.textarea && !this.textarea.value.trim()) event.formData.delete(this.textarea.name);
      }

      // Paid mode: once the product is in the cart, add one Gift Packing item for it (once per product)
      onCartUpdate(event) {
        if (event.source !== 'product-form' || !this.checkbox.checked || !this.form) return;
        const formVariant = this.form.querySelector('[name="id"]');
        if (!formVariant || String(event.productVariantId) !== formVariant.value) return;

        const variantId = Number(this.dataset.variantId);
        const productTitle = this.dataset.productTitle;

        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const alreadyAdded = cart.items.some(
              (item) => item.variant_id === variantId && item.properties && item.properties.For === productTitle
            );
            if (alreadyAdded) return;

            return fetch(`${routes.cart_add_url}`, {
              ...fetchConfig('javascript'),
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1, properties: { For: productTitle } }],
                sections: 'cart-icon-bubble',
                sections_url: window.location.pathname,
              }),
            })
              .then((response) => response.json())
              .then((response) => {
                if (response.status) throw new Error(response.description || response.message);
                this.updateCartIcon(response.sections && response.sections['cart-icon-bubble']);
              });
          })
          .catch((error) => console.error('Gift packing could not be added:', error));
      }

      // Paid mode: Shopify's dynamic "Buy it now" button goes straight to checkout without the theme's JS,
      // so the gift packing charge would be skipped. While gift packing is ticked, swap it for a theme
      // button that adds the product and the Gift Packing item to the cart, then opens checkout.
      toggleBuyNow(active) {
        if (!this.form) return;
        const paymentButton = this.form.querySelector('.shopify-payment-button');
        if (!paymentButton) return;

        if (!this.buyNowButton) {
          this.buyNowButton = document.createElement('button');
          this.buyNowButton.type = 'button';
          this.buyNowButton.className = 'button button--full-width gift-packing__buy-now';
          this.buyNowButton.textContent = this.dataset.buyNowLabel;
          this.buyNowButton.addEventListener('click', this.onBuyNow.bind(this));

          this.buyNowError = document.createElement('p');
          this.buyNowError.className = 'gift-packing__buy-now-error';
          this.buyNowError.setAttribute('role', 'alert');
          this.buyNowError.hidden = true;
        }

        if (active) {
          paymentButton.after(this.buyNowButton, this.buyNowError);
        } else {
          this.buyNowButton.remove();
          this.buyNowError.remove();
        }
        this.form.classList.toggle('gift-packing--buy-now', active);
      }

      onBuyNow() {
        const submitButton = this.form.querySelector('[type="submit"][name="add"]');
        if (submitButton && submitButton.disabled) return;
        if (this.buyNowButton.getAttribute('aria-disabled') === 'true') return;

        this.buyNowButton.setAttribute('aria-disabled', true);
        this.buyNowButton.classList.add('loading');
        this.buyNowError.hidden = true;

        const formData = new FormData(this.form);
        const item = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1), properties: {} };
        if (formData.get('selling_plan')) item.selling_plan = formData.get('selling_plan');
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string' && value !== '') item.properties[match[1]] = value;
        }

        const variantId = Number(this.dataset.variantId);
        const productTitle = this.dataset.productTitle;

        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const items = [item];
            const alreadyAdded = cart.items.some(
              (cartItem) => cartItem.variant_id === variantId && cartItem.properties && cartItem.properties.For === productTitle
            );
            if (!alreadyAdded) items.push({ id: variantId, quantity: 1, properties: { For: productTitle } });

            return fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body: JSON.stringify({ items }) });
          })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) throw new Error(response.description || response.message);
            window.location.href = '/checkout';
          })
          .catch((error) => {
            this.buyNowError.textContent = error.message || 'Something went wrong. Please try again.';
            this.buyNowError.hidden = false;
            this.buyNowButton.removeAttribute('aria-disabled');
            this.buyNowButton.classList.remove('loading');
          });
      }

      updateCartIcon(html) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      }
    }
  );
}
